import styled from 'styled-components';

const WrapperDiv = styled.div`
  height: 100%;
  width: 100%;
  padding: 2rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.background};
  text-align: center;
`;

const ImgDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
`;

export {
    WrapperDiv,
    ImgDiv,
    Img
};